import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import ButtonCore from '../Button/ButtonCore';
import Proportion from '../Proportion';

import { dataHooks } from './FillPreview.constants';
import type { FillPreviewProps } from './FillPreview.types';
import { st, classes } from './FillPreview.st.css';
import { useStyledContent } from './hooks/useStyledContent';

export const FillPreview = forwardRef<HTMLDivElement, FillPreviewProps>(
  (
    {
      selected = false,
      className,
      aspectRatio,
      dataHook,
      disabled,
      fill,
      size,
      contentClassName,
      ...rest
    }: FillPreviewProps,
    ref,
  ) => {
    const {
      children,
      contentClassName: updatedContentClassName,
      style,
    } = useStyledContent({
      contentClassName,
      disabled,
      fill,
    });

    return (
      <div ref={ref} className={st(classes.root, { size }, className)}>
        <Proportion dataHook={dataHook} aspectRatio={aspectRatio}>
          <ButtonCore
            {...rest}
            data-selected={selected}
            className={st(classes.button, {
              selected,
              empty: !fill && !disabled,
            })}
            data-hook={dataHooks.button}
            disabled={disabled}
            style={style}
            contentClassName={updatedContentClassName}
            children={children}
          />
        </Proportion>
      </div>
    );
  },
);

FillPreview.propTypes = {
  dataHook: PropTypes.any,
  className: PropTypes.any,
  as: PropTypes.any,
  fill: PropTypes.any,
  selected: PropTypes.any,
  disabled: PropTypes.any,
  aspectRatio: PropTypes.any,
  size: PropTypes.any,
};

export default FillPreview;
